/* global customElements */

import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';
import Chart from 'chart.js/auto';

//https://www.chartjs.org/docs/

class ChartPanel extends BaseComponent {

	static get properties() {
		return {			
			divStyle: {type: String},
			chartContainerId: {type: String},			
			delayInit: {type: Number}
		};
	}
	
	constructor() {
		super();
		
		var chartPanel = this;	
		chartPanel.divStyle = '';
		chartPanel.chartContainerId = 'chartId';
		chartPanel.delayInit = 0;
		chartPanel.chart = null;
			
		setTimeout(function(){
			chartPanel.init();
		}, chartPanel.delayInit);
	}
	
	render() {	
		return html`
			<slot></slot>
		`;
	}
	
	init() {
		var chartPanel = this;
		
		chartPanel.style.display = chartPanel.style.display || 'block';
		chartPanel.style.width = chartPanel.style.width || '100%';
		chartPanel.style.height = chartPanel.style.height || '100%';
		if (chartPanel.divStyle) {
			var styleParts = chartPanel.divStyle.split(';');
			styleParts.forEach(function(stylePart) {
				var separatorIndex = stylePart.indexOf(':');
				if (separatorIndex > 0) {
					var styleName = stylePart.substring(0, separatorIndex).trim();
					var styleValue = stylePart.substring(separatorIndex + 1).trim();
					if (styleName && styleValue) {
						chartPanel.style[styleName] = styleValue;
					}
				}
			});
		}
		
		chartPanel.canvas = ElementUtil.create({
			tag: 'canvas'			
		});
		chartPanel.append(chartPanel.canvas);
		
		var readyEvent = new CustomEvent('ready', { detail: chartPanel });
		chartPanel.dispatchEvent(readyEvent);
	}
	
	disconnectedCallback() {
		super.disconnectedCallback();
		this.destroyChart();
	}
	
	destroyChart() {
		if (this.chart) {
			this.chart.destroy();
			this.chart = null;
		}
	}
	
	_demoConfig() {
		return {
			type: 'bar',
			data: {
				labels: ['Red', 'Blue6', 'Yellow', 'Green', 'Purple', 'Orange'],
				datasets: [{
					label: '# of Votes',
					data: [12, 19, 3, 5, 2, 3],
					borderWidth: 1
				}]
			},
			options: {
				responsive: true,
				maintainAspectRatio: false,
				scales: {
					y: {
						beginAtZero: true
					}
				}
			}
		};
	}
	
	_normalizeConfig(options) {
		var config = options ? Object.assign({}, options) : this._demoConfig();
		config.options = Object.assign({
			responsive: true,
			maintainAspectRatio: false
		}, config.options || {});
		return config;
	}
	
	createChart(options) {
		var chartPanel = this;

		var renderChart = function() {
			chartPanel.destroyChart();
			chartPanel.chart = new Chart(chartPanel.canvas, chartPanel._normalizeConfig(options));
		};

		if (chartPanel.canvas) {
			renderChart();
		} else {
			setTimeout(function(){
				if (chartPanel.canvas) {
					renderChart();
				}
			}, 50);
		}
	}
	
	updateChart(configOrData) {
		var chartPanel = this;
		if (!chartPanel.canvas) {
			setTimeout(function() {
				chartPanel.updateChart(configOrData);
			}, 50);
			return;
		}
		
		if (!configOrData) {
			return;
		}
		
		// Full Chart.js config (has type or top-level data+options)
		if (configOrData.type || (configOrData.data && configOrData.options !== undefined)) {
			chartPanel.createChart(configOrData);
			return;
		}
		
		// Partial data update: { labels, datasets } or Chart.js data object
		if (chartPanel.chart && configOrData.labels && configOrData.datasets) {
			chartPanel.chart.data.labels = configOrData.labels;
			chartPanel.chart.data.datasets = configOrData.datasets;
			chartPanel.chart.update();
			return;
		}
		
		if (chartPanel.chart && configOrData.datasets) {
			chartPanel.chart.data = Object.assign({}, chartPanel.chart.data, configOrData);
			chartPanel.chart.update();
			return;
		}
		
		chartPanel.createChart(configOrData);
	}

};
customElements.define('dl-chart-panel', ChartPanel);
